export var VersionsMetaframe;
(function (VersionsMetaframe) {
    VersionsMetaframe["V0_3"] = "0.3";
    VersionsMetaframe["V0_4"] = "0.4";
})(VersionsMetaframe || (VersionsMetaframe = {}));
export var VersionsMetapage;
(function (VersionsMetapage) {
    VersionsMetapage["V0_2"] = "0.2";
    VersionsMetapage["V0_3"] = "0.3";
})(VersionsMetapage || (VersionsMetapage = {}));
export const MetaframeVersionsAll = Object.keys(VersionsMetaframe);
export const MetaframeVersionCurrent = VersionsMetaframe.V0_4;
export const MetapageVersionsAll = Object.keys(VersionsMetapage);
export const MetapageVersionCurrent = VersionsMetapage.V0_3;
//# sourceMappingURL=versions.js.map